<div [ngStyle]="{'width': modalSize.width+'px', 'max-width':  modalSize.width+'px', 'height':  modalSize.height+'px'}">
	<div class="row">
		<div class="col-md-4">&nbsp;</div>
		<div class="col-md-4 col-6 jmPageTitle" style="text-align: center; margin-top: 20px; margin-bottom: 20px;" title="Image=>w:{{imageWidth}}, h:{{imageHeight}}, Client=>w:{{clientWidth}},h:{{clientHeight}}">Crop Image</div>
		<div class="col-md-4 col-6 crop-option-col">
			<i class="fa fa-rotate-left h4 text-primary" role="button" (click)="rotate(false)" style="margin-right:20px;"></i>
			<i class="fa fa-rotate-right h4 text-primary" role="button" (click)="rotate(false)" style="margin-right:20px;"></i>
			<span role="button" (click)="cancel()" class="jmCloseBtn"></span>
		</div>
	</div>
	<div class="row">
		<div class="col-12 text-center">
			<div id="divCanvas" [ngStyle]="{'margin':'auto', 'width':canvasSize.width+'px', 'height': canvasSize.height+'px'}">
				<image-cropper #imageCropper
							   *ngIf="selectedImage"
							   format="png"
							   output="base64"
							   [imageChangedEvent]="imageChangedEvent"
							   [imageBase64]="selectedImage"
							   [maintainAspectRatio]="true"
							   [aspectRatio]="aspectRatio"
							   [roundCropper]="roundCropper"
							   [resizeToWidth]="resizeToWidth"
							   [resizeToHeight]="resizeToHeight"
							   [backgroundColor]="'silver'"
							   (imageCropped)="imageCropped($event)"
							   (imageLoaded)="imageLoaded()"
							   (cropperReady)="cropperReady()"
							   (loadImageFailed)="loadImageFailed()">
				</image-cropper>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-4">&nbsp;</div>
		<div class="col-4 text-center" style="margin-top: 20px;">
			<button name="saveBtn" class="btn btn-primary" (click)="save()" [disabled]="croppedImage==null">Done</button>
		</div>
		<div class="col-4">&nbsp;</div>
	</div>
</div>
